import { render, staticRenderFns } from "./onlineService.vue?vue&type=template&id=dd6fa50a&scoped=true&"
import script from "./onlineService.vue?vue&type=script&lang=js&"
export * from "./onlineService.vue?vue&type=script&lang=js&"
import style0 from "./onlineService.vue?vue&type=style&index=0&id=dd6fa50a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6fa50a",
  null
  
)

export default component.exports